import { gql } from '@apollo/client';

const Fragments = {
  checklistsItem: gql`
    fragment checklistsItem on Checklist {
      id
      reqDocTypeId
      targetAreaId
      documentName
      documentCode
      sharePointContentType
      mandatoryYN
      defaultYN
      targetAreaName
    }
  `
};

export default Fragments;
